import { type FormEvent, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { fieldErrors, message } from '../lib/errors.ts';
import { Banner, Button, Field, Page } from '../ui/index.tsx';

export function Register() {
  const { me, api, liff, refreshMe, shop } = useShop();
  const { go, href } = useShopPaths();
  const [params] = useSearchParams();
  const next = params.get('next') || '/book';
  const [fullName, setFullName] = useState(me.customer?.fullName ?? liff.getDecodedIDToken()?.name ?? '');
  const [phone, setPhone] = useState(me.customer?.phone ?? '');
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (me.customer?.registered) go(next, { replace: true });
  }, [me.customer?.registered, go, next]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!consent) {
      setErrors({ consent: 'กรุณายอมรับนโยบายความเป็นส่วนตัว' });
      return;
    }
    setErrors({});
    setSaving(true);
    try {
      await api.register({ fullName, phone, consent });
      await refreshMe();
      go(next, { replace: true });
    } catch (err) {
      const f = fieldErrors(err);
      if (Object.keys(f).length > 0) setErrors(f);
      else setError(message(err));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Page title="สมัครสมาชิก">
      <p className="muted" style={{ marginBottom: 16 }}>สมัครครั้งเดียว จองคิวกับ {shop.name} ได้ทุกครั้ง</p>
      {error && <Banner kind="error">{error}</Banner>}
      <form onSubmit={submit} noValidate>
        <Field label="ชื่อ-นามสกุล" error={errors.name ?? errors.fullName}>
          <input value={fullName} onChange={(e) => setFullName(e.target.value)} autoComplete="name" maxLength={60} />
        </Field>
        <Field label="เบอร์โทรศัพท์" error={errors.phone} hint="ร้านจะใช้ติดต่อเรื่องการจองเท่านั้น">
          <input value={phone} onChange={(e) => setPhone(e.target.value)} inputMode="tel" autoComplete="tel" maxLength={20} placeholder="08x-xxx-xxxx" />
        </Field>
        <label className="check">
          <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
          <span>ฉันยอมรับ <Link to={href('/privacy')}>นโยบายความเป็นส่วนตัว</Link> และยินยอมให้ร้านเก็บชื่อและเบอร์โทรเพื่อการจองคิว</span>
        </label>
        {errors.consent && <p className="field-msg error" role="alert">{errors.consent}</p>}
        <div style={{ height: 16 }} />
        <Button type="submit" block loading={saving}>สมัครสมาชิก</Button>
      </form>
    </Page>
  );
}
